import request from '@/router/axios'
import {getRefreshToken} from '@/utils/auth'

const DEFAULT_TENANT_CODE = 'gitee'
// const baseTenantUrl = 'http://api.exam.chineseall.cn:8081'
const baseTenantUrl = 'http://47.92.102.238:8080'

export function loginByUsername( data) {
  return request({
    url: baseTenantUrl+'/auth/user/v1/h5/login',
    headers: {
      "Content-Type": "application/json",
    },
    method: 'post',
    data: data,
  })
}


//重新设置密码
export function setPassword( password,confrim,phonenumber, code) {
  return request({
    url: baseTenantUrl+'/auth/h5/resetpwd',
    headers: {
      "Content-Type": "application/json",
    },
    method: 'post',
    data: {password:password,confrim:confrim, phonenumber:phonenumber, code:code},
  })
}

//修改密码
export function changePwd( oldPassword,password,confrim) {
  return request({
    url: baseTenantUrl+'/auth/h5/changepwd',
    headers: {
      "Content-Type": "application/json",
    },
    method: 'post',
    data: {oldPassword:oldPassword,password:password,confrim:confrim},
  })
}


/**
 * 根据手机号登录
 */
export function loginBySocial(tenantCode = DEFAULT_TENANT_CODE, social, code) {
  const grantType = 'mobile'
  const scope = 'read'
  if (tenantCode === '') {
    tenantCode = DEFAULT_TENANT_CODE
  }
  return request({
    url: baseTenantUrl+'/auth/mobile/login',
    headers: {
      'tenant_code': tenantCode
    },
    method: 'post',
    params: {mobile: social, code, grant_type: grantType, scope}
  })
}

//手机验证码注册
// phonenumber, code,password, tenantId
export function registerByUsername(data) {
   return request({
    url: baseTenantUrl+'/auth/user/v1/h5/register',
    headers: {
      "Content-Type": "application/json",
    },
    method: 'post',
    data,
  })
}

export function logout() {
  return request({
    url: baseTenantUrl+'/auth/user/v1/token/logout',
    method: 'get'
  })
}
//检查手机号是否可以注册
export function checkRegister(mobile) {
  return request({
    url: baseTenantUrl+'/auth/v1/moblie/check/'+ mobile,
    method: 'get'
  })
}


//获取个人信息
export function getUserInfo(token) {
  return request({
    url: baseTenantUrl+'/system/user/h5/userinfo',
    method: 'get'
  })
}

// 修改用户信息
export function updateUserInfo(data) {
  return request({
    url: baseTenantUrl+'/auth/h5/modify/userinfo',
    headers: {
      "Content-Type": "application/json",
    },
    method: 'post',
    data
  })
}

/**
 * 刷新token
 */
//有效期刷新token的接口
export function refreshToken() {
  return request({
    url: baseTenantUrl+'/auth/refresh',
    method: 'post',
  })
}



// WEBPACK FOOTER //
// ./src/api/admin/login.js